/**
 *  @public
 **/
export enum ICON {
  ALERT_TRIANGLE = 'alert-triangle',
  AMEN = 'amen',
  ANNOUNCEMENT = 'announcement',
  APPLE = 'apple',
  ARROW_IN = 'arrow-in',
  ARROW_LEFT = 'arrow-left',
  ARROW_OUT = 'arrow-out',
  ARROW_RIGHT = 'arrow-right',
  ARROW_UP_LEFT = 'arrow-up-left',
  AUDIO = 'audio',
  BELL = 'bell',
  BIG_HANDS = 'big-hands',
  BIRTHDAY = 'birthday',
  BOOK_OPEN = 'book-open',
  BOOKMARK = 'bookmark',
  BOOKMARK_FILL = 'bookmark-fill',
  BOOKMARK_X = 'bookmark-x',
  BRANCH = 'branch',
  BURGER_MENU = 'burger-menu',
  CALENDAR = 'calendar',
  CALENDAR_CHECK = 'calendar-check',
  CHECK_DASH = 'check-dash',
  CHECK_SOLID = 'check-solid',
  CHECK = 'check',
  CHECK_CIRCLE_BROKEN = 'check-circle-broken',
  CHEVRON_COLLAPSABLE_CLOSE = 'chevron-collapsable-close',
  CHEVRON_COLLAPSABLE_OPEN = 'chevron-collapsable-open',
  CHEVRON_LEFT = 'chevron-left',
  CHEVRON_RIGHT = 'chevron-right',
  CHEVRON_UP = 'chevron-up',
  CHEVRON_DOWN = 'chevron-down',
  CLOCK_CHECK = 'clock-check',
  CLOSE = 'close',
  COMMENT = 'comment',
  COMMUNITY = 'community',
  CONTACTS = 'contacts',
  CONFESSIO = 'confessio',
  COPY = 'copy',
  CORNER_UP_LEFT_REPLY = 'corner-up-left-reply',
  CROSS = 'cross',
  DEVICES = 'devices',
  DOT = 'dot',
  DOTTED_LINE = 'dotted-line',
  ELLIPSIS_HORIZONTAL = 'ellipsis-horizontal',
  ELLIPSIS_VERTICAL = 'ellipsis-vertical',
  EMBED = 'embed',
  ERROR_SOLID = 'error-solid',
  EVENT = 'event',
  EXPLORER = 'explorer',
  EYE = 'eye',
  EDIT = 'edit',
  FACEBOOK = 'facebook',
  FACE_HAPPY = 'face-happy',
  FILTER = 'filter',
  FIRE = 'fire',
  GLOBE = 'globe',
  GOOGLE = 'google',
  HAND_HI = 'hand-hi',
  HANDS = 'hands',
  HEART = 'heart',
  HELP_OFF = 'help-off',
  HELP_ON = 'help-on',
  HOME = 'home',
  HOURGLASS_END = 'hourglass-end',
  HOURGLASS_HALF = 'hourglass-half',
  HOURGLASS_START = 'hourglass-start',
  HOZANA = 'hozana',
  HOZANA_APP = 'hozana-app',
  HOZANA_INTENTION = 'hozana-intention',
  HOZANA_FIRE = 'hozana-fire',
  IMAGE = 'image',
  INCOGNITO = 'incognito',
  INFO_CIRCLE = 'info-circle',
  INSTAGRAM = 'instagram',
  INTENTION = 'intention',
  JOBS = 'jobs',
  QUESTION_CIRCLE = 'question-circle',
  KEY = 'key',
  LABEL = 'label',
  LANTERN = 'lantern',
  LAPTOP = 'laptop',
  LEAVE = 'leave',
  LETTER = 'letter',
  LETTER_SOLID = 'letter-solid',
  LIGHTBULB = 'lightbulb',
  LINK = 'link',
  LIVE = 'live',
  LOADER = 'loader',
  LOCK = 'lock',
  MAGNIFIER = 'magnifier',
  MAIL = 'mail',
  MESSAGING = 'messaging',
  MARKER_PIN = 'marker-pin',
  MARKER_PLACE = 'marker-place',
  MESSAGE_CHAT = 'message-chat',
  MESSAGE_HEART = 'message-heart',
  MESSAGE_INFO = 'message-info',
  MESSAGE_QUESTION = 'message-question',
  MESSAGE_TRIANGLE = 'message-triangle',
  MESSENGER = 'messenger',
  MOBILE = 'mobile',
  NOT_FOUND = 'not-found',
  NOTIFICATION = 'notification',
  NOTIFICATION_MESSAGE = 'notification-message',
  PARTY = 'party',
  PATH = 'path',
  PENCIL = 'pencil',
  PHONE = 'phone',
  PINTEREST = 'pinterest',
  PLACE = 'place',
  PLAY_CIRCLE = 'play-circle',
  PLAY = 'play',
  PAUSE_CIRCLE = 'pause-circle',
  PLUS = 'plus',
  PRAYER_SPACE = 'prayer-space',
  PRINT = 'print',
  PRIVATE = 'private',
  PROFILE = 'profile',
  PROFILE_CIRCLE = 'profile-circle',
  QUOTE_START = 'quote-start',
  QUOTE_END = 'quote-end',
  RADIO_OFF = 'radio-off',
  RADIO_ON = 'radio-on',
  REFRESH = 'refresh',
  REPLY = 'reply',
  ROAD = 'road',
  ROAD_STOP = 'road-stop',
  ROLE = 'role',
  ROSARIO_SOLID_GRADIENT = 'rosario-solid-gradient',
  SAFE_SHIELD = 'safe-shield',
  SEARCH = 'search',
  SEND = 'send',
  SEND_SOLID = 'send-solid',
  SETTINGS = 'settings',
  SHARE = 'share',
  SLASH_CIRCLE = 'slash-circle',
  SLIDERS = 'sliders',
  STARS = 'stars',
  STARS_BIG = 'stars-big',
  STAR_OFF = 'star-off',
  STAR_ON = 'star-on',
  STATISTICS = 'statistics',
  STOP = 'stop',
  STORYBOOK = 'storybook',
  STREAK_FLAME = 'streak-flame',
  TEXT = 'text',
  TRASH = 'trash',
  TIKTOK = 'tiktok',
  THUMBS_UP = 'thumbs-up',
  TWITTER = 'twitter',
  USER_EDIT = 'user-edit',
  USERS = 'users',
  VIDEO_RECORDER = 'video-recorder',
  WAIT_CIRCLE = 'wait-circle',
  WALLET = 'wallet',
  WIFI_OFF = 'wifi-off',
  WHATSAPP = 'whatsapp',
  YOUTUBE = 'youtube',
}
